import { Box } from "components/shared/box"
import { Text } from "components/shared/text"
import type { ReactNode } from "react"
import styles from "./item-page-block-wrapper.module.scss"

type ItemPageBlockWrapperProps = {
  title: string
  children: ReactNode
}
export function ItemPageBlockWrapper({ title, children }: ItemPageBlockWrapperProps) {
  return (
    <Box className={`rounded-2xl p-6 mb-8 ${styles["item-page-wrapper"]}`}>
      <Text weight="bold" size="title" className="mb-8">
        {title}
      </Text>
      {children}
    </Box>
  )
}
